"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_virtualized_1 = require("@vidazoo/ui-virtualized");
var classnames_1 = require("classnames");
var common_1 = require("../../common");
var DataGridColumn = /** @class */ (function (_super) {
    tslib_1.__extends(DataGridColumn, _super);
    function DataGridColumn(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setMouseOver = function () {
            _this.setState({ mouseOver: true });
        };
        _this.setMouseLeave = function () {
            _this.setState({ mouseOver: false });
        };
        _this.state = { mouseOver: false };
        return _this;
    }
    DataGridColumn.prototype.render = function () {
        var _a;
        var _b = this.props, width = _b.width, children = _b.children, className = _b.className, theme = _b.theme, density = _b.density, mouseOnRow = _b.mouseOnRow, isFreeze = _b.isFreeze, tooltip = _b.tooltip, others = tslib_1.__rest(_b, ["width", "children", "className", "theme", "density", "mouseOnRow", "isFreeze", "tooltip"]);
        var classes = classnames_1.default(theme.column, className, (_a = {},
            _a[theme.mouseover] = tooltip && this.state.mouseOver,
            _a[theme.mouseonrow] = mouseOnRow && !isFreeze,
            _a[theme.freeze] = isFreeze,
            _a[theme.small] = density && density === common_1.Density.Small,
            _a[theme.medium] = density && density === common_1.Density.Medium,
            _a[theme.large] = density && density === common_1.Density.Large,
            _a));
        var props = {};
        if (tooltip) {
            props.onMouseOver = this.setMouseOver;
            props.onMouseLeave = this.setMouseLeave;
        }
        if (tooltip && this.state.mouseOver) {
            return (React.createElement(ui_virtualized_1.Column, tslib_1.__assign({ width: width }, props, others, { className: classes }),
                React.createElement("div", { className: theme.tooltip }, children)));
        }
        return (React.createElement(ui_virtualized_1.Column, tslib_1.__assign({ width: width }, props, others, { className: classes }), children));
    };
    DataGridColumn.defaultProps = {};
    return DataGridColumn;
}(React.Component));
exports.default = DataGridColumn;
